/**
 * WizardHeader Component (Luxury Design)
 * Multi-step wizard header with progress indicator
 * Features: Square design, monochromatic, serif typography
 */

import { ArrowLeft } from 'lucide-react';

const WizardHeader = ({
  title,
  currentStep,
  totalSteps = 4,
  onBack
}) => {
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="bg-brand-dark dark:bg-brand-light">
      {/* Header */}
      <div className="px-4 pt-4 pb-3">
        <div className="flex items-center justify-between">
          {/* Left Section - Back Button */}
          <div className="flex-shrink-0 w-10">
            <button
              onClick={onBack}
              className="p-2 hover:bg-brand-light/10 dark:hover:bg-brand-dark/10 rounded-lg transition-all duration-300"
            >
              <ArrowLeft size={22} className="text-brand-light dark:text-brand-dark" strokeWidth={1.5} />
            </button>
          </div>

          {/* Center Section - Title */}
          <div className="flex-1 text-center">
            <h1 className="text-lg font-semibold text-brand-light dark:text-brand-dark">
              {title}
            </h1>
          </div>

          {/* Right Section - Step Indicator */}
          <div className="flex-shrink-0 w-10 text-right">
            <span className="text-xs text-brand-light/70 dark:text-brand-dark/70 font-medium">
              {currentStep}/{totalSteps}
            </span>
          </div>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="px-4 pb-3">
        <div className="w-full bg-brand-light/20 dark:bg-brand-dark/20 h-1 rounded-full overflow-hidden">
          <div
            className="bg-brand-light dark:bg-brand-dark h-1 transition-all duration-500 ease-out"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default WizardHeader;